import React, { FC, ReactNode } from "react";
import { NoDataFound } from "../../../../components/common/NoDataFound";

interface TableRowProp {
    children: ReactNode;
}

interface TableDataProp {
    children: ReactNode;
}

interface TableHeadProp {
    children: ReactNode;
}

// Start Stock Summary TableComponent
interface StockSummaryTableProps {
  data: any[];
}



export const StockSummaryTable: FC<StockSummaryTableProps> = ({ data }) => {
  
  

  if( data.length === 0 ){
     return <NoDataFound/>
   }



  return (
    <div className="table-responsive">
    <table
      className="table"
    >
      <thead>
        <TableRow>
          <TableHead>Month</TableHead>
          <TableHead>Total Order</TableHead>
          <TableHead>Pending</TableHead>
          <TableHead>Processing</TableHead>
          <TableHead>Delivered</TableHead>
          <TableHead>Paid</TableHead>
          <TableHead>Due</TableHead>
        </TableRow>
      </thead>
      <tbody style={{ height: "50px", verticalAlign: "middle" }}>
        {data.map((item: any, index: number) => (
          <TableRow key={item?.month}>
            <TableData>{item?.month_name}</TableData>
            <TableData>{item?.total_orders}</TableData>
            <TableData>{item?.pending_orders}</TableData>
            <TableData>{item?.processing_orders}</TableData>
            <TableData>{item?.delivered_orders}</TableData>
            <TableData>{item?.paid_orders}</TableData>
            <TableData>{item?.due_orders}</TableData>
          </TableRow>
        ))}
      </tbody>
    </table>
    </div>
  );
};



const TableRow: FC<TableRowProp> = ({ children }) => {
   return <tr>{children}</tr>;
};

  const TableHead: FC<TableHeadProp> = ({ children }) => {
    return <th className="px-5 border-bottom" style={{color:'#667085',fontSize:'14px',fontWeight:500}} scope="col">{children}</th>;
  };

  
  const TableData: FC<TableDataProp> = ({ children }) => {
    return <td className="px-5 border-bottom" style={{color:'#444A6D',fontSize:'13px'}}>{children}</td>;
  };
